import { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { Toaster } from "sonner";
import { IMAGES } from "../../data/content";
import { crmForgot } from "../../lib/crm";

export default function CrmForgot() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await crmForgot(email);
      setDone(true);
    } catch {
      setDone(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain-overlay flex min-h-screen items-center justify-center bg-[#141210] px-5">
      <Toaster position="top-center" richColors />
      <div className="relative z-10 w-full max-w-sm rounded-3xl border border-gold/20 bg-white/5 p-8 backdrop-blur-sm sm:p-10">
        <img src={IMAGES.logo} alt="Logo Ministério AURA" className="mx-auto h-14 w-14 rounded-full object-cover" />
        {done ? (
          <div className="mt-8 text-center" data-testid="crm-forgot-success">
            <CheckCircle2 className="mx-auto h-10 w-10 text-teal" />
            <h1 className="mt-4 font-serif text-2xl text-white">Verifique as instruções</h1>
            <p className="mt-3 text-sm leading-relaxed text-white/60">
              Se o e-mail estiver cadastrado, um link de redefinição de senha foi
              gerado. Fale com a administração para recebê-lo.
            </p>
          </div>
        ) : (
          <>
            <h1 className="mt-6 text-center font-serif text-2xl text-white">Recuperar senha</h1>
            <p className="mt-3 text-center text-sm text-white/60">
              Informe o e-mail administrativo para gerar um link de redefinição.
            </p>
            <form onSubmit={handleSubmit} className="mt-8 space-y-4" data-testid="crm-forgot-form">
              <input
                data-testid="crm-forgot-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-white outline-none transition-colors focus:border-gold/60"
                placeholder="voce@email.com"
              />
              <button
                data-testid="crm-forgot-submit"
                type="submit"
                disabled={loading}
                className="w-full rounded-full bg-gold py-3.5 text-xs font-semibold uppercase tracking-[0.2em] text-ink transition-colors hover:bg-champagne disabled:opacity-60"
              >
                {loading ? <Loader2 className="mx-auto h-4 w-4 animate-spin" /> : "Gerar link de redefinição"}
              </button>
            </form>
          </>
        )}
        <Link
          to="/crm/login"
          className="mt-6 block text-center text-[10px] uppercase tracking-[0.2em] text-white/40 transition-colors hover:text-champagne"
        >
          Voltar ao login
        </Link>
      </div>
    </div>
  );
}
